import { Navigate } from 'react-router-dom';

import { ROUTES } from '../../constants';
import { isMarketingHost } from '../../utils/siteHost';

/** Unknown paths: marketing → home; app → dashboard. */
export function MarketingCatchAllRoute() {
  if (isMarketingHost()) {
    return <Navigate to={ROUTES.HOME} replace />;
  }
  return <Navigate to={ROUTES.DASHBOARD} replace />;
}
